import { render } from "./invite_card.vue?vue&type=template&id=ae0bb38a"
import script from "./invite_card.vue?vue&type=script&lang=js"
export * from "./invite_card.vue?vue&type=script&lang=js"

import "./invite_card.vue?vue&type=style&index=0&id=ae0bb38a&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__